import axios from "axios";

export function getPlaylist(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Playlist/getlist", config);
}

export function deletePlaylist(id) {
  const config = {
    params: {
      id: id,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Playlist/deleted", config);
}

export function getPlaylistVideosList(playlistid) {
  const config = {
    params: {
      playlistid: playlistid,
    }
  };
  return axios.get(process.env.VUE_APP_API_URL + "Playlist/getplaylistvideosList", config);
}

export function postVideo(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Playlist/insert", data);
}

export function updatePlaylist(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Playlist/update", data);
}

export function postClassPersonelPlaylist(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Playlist/postClassPersonelPlaylist", data);
}

export function getSuggestedPlaylist() {
  return axios.get(process.env.VUE_APP_API_URL + "Playlist/getsuggestedplaylist");
}